import React, { Fragment } from "react";
import YellowConfirm from "./YellowConfirm";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Button from "./Button";
import { connect } from "react-redux";
import {
  addVersamento,
  getAllApartments,
  hideNotification,
  setEvaded,
} from "../reducers/apartments";
import { printTransactions } from "../services/createPdf";

function randomDate(start, end) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

const textAllert = [
  {
    text: "Attenzione",
    fontSize: 32,
    paddingBottom: "3vh",
  },
  {
    text:
      "L'operazione stamperà tutti gli ordini nuovi e rimuoverà le icone di notifica degli appuntamenti.",
    fontSize: 18,
  },
  {
    text: "Confermi?",
    fontSize: 18,
    paddingBottom: "3vh",
  },
];

const headerTabella = [
  {
    text: "Codice Operazione",
  },
  {
    text: "Data",
  },
  {
    text: "Descrizione",
  },
  {
    text: "Movimento",
  },
];

const paddingLeft = "1.2vh";
const titleStyle = {
  color: "#645B40",
  fontSize: 36,
  paddingTop: paddingLeft,
  paddingLeft: paddingLeft,
};

const columnStyle = {
  width: "20.95vw",
  border: "solid",
  borderWidth: 1,
  marginLeft: -1,
  textAlign: "center",
  padding: "0.4vh",
  marginTop: -1,
};

let data1 = React.createRef();
let data2 = React.createRef();
let data = React.createRef();
let versamento = React.createRef();

class Bilancio extends React.Component {
  state = {
    ultimeOperazioni: true,
    data1: "2021-01-01",
    data2: new Date(),
    openStampa1: false,
    openStampa2: false,
    openStampaVersamento: false,
    openStampaVersamento1: false,
    openStampaVersamento2: false,
    versamento: 0,
    user: this.props.apartment.name,
    visualizzare: 10,
    dataVersamento: "[Data]",
  };

  confirm = () => {
    const versamenti = this.props.apartment.user.versamenti;
    const servizi = this.props.apartment.user.servizi;

    const transactions = this.renderToPrint([...servizi, ...versamenti]);

    printTransactions([
      {
        apartment: this.props.apartment.name,
        saldo: this.renderTotal(transactions),
        transactions: transactions.map((t) => {
          return {
            ...t,
            total: this.returnPrice(t) + "€",
          };
        }),
      },
    ]);

    // this.setState({ openStampa2: !this.state.openStampa2 });
    // this.setState({ openStampa1: !this.state.openStampa1 });
    // setTimeout(() => {
    //   this.setState({ openStampa2: !this.state.openStampa2 });
    // }, 1200);
  };

  confirmVersamento = () => {
    this.props.addVersamento(
      new Date(this.state.dataVersamento).toISOString(),
      this.state.versamento
    );

    this.setState({ openStampaVersamento2: !this.state.openStampaVersamento2 });
    this.setState({ openStampaVersamento1: !this.state.openStampaVersamento1 });
    setTimeout(() => {
      this.setState({ openStampaVersamento2: !this.state.openStampaVersamento2 });
    }, 1200);
  };

  setDate = () => {
    this.setState({
      data1: data1.current.value,
      data2: data2.current.value,
      ultimeOperazioni: false,
    });
    data1.current.value = "";
    data2.current.value = "";
  };

  removeDate = () => {
    data1.current.input = "01-01-2020";
    data2.current.input = new Date();
    this.setState({
      data1: data1.current.input,
      data2: data2.current.input,
      ultimeOperazioni: true,
    });
  };

  ISOtoLongDate = (isoString) => {
    const options = { month: "long", day: "numeric", year: "numeric" };
    const date = new Date(isoString);
    const longDate = new Intl.DateTimeFormat("it-IT", options).format(date);
    return longDate;
  };

  sumTotal = (array) => {
    return array.reduce(function (acc, val) {
      return acc + val;
    }, 0);
  };

  returnPrice = (obj) => {
    // console.log("vers", obj);

    const total =
      (Number(obj.prezzo) || 0) +
      (obj.data
        ? Array.isArray(obj.data)
          ? obj.data.reduce((acc, curr) => {
              return acc + Number(curr.prezzo || 0) * Number(curr.numero || 1);
            }, 0)
          : Number(obj.data.prezzo || 0)
        : 0);
    if (obj.descrizione == "Versamento") {
      return "+" + obj.movimento.toFixed(2);
    } else {
      return "-" + total.toFixed(2);
    }
  };

  renderTotal = (array) => {
    var tot = 0;
    for (var i = 0; i < array.length; i++) {
      tot = tot + parseInt(this.returnPrice(array[i]));
    }
    return tot;
  };

  renderToPrint = (arr) => {
    return arr
      .sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })
      .filter((item) => {
        return (
          item.createdAt >= new Date(this.state.data1).toISOString() &&
          item.createdAt <= new Date(this.state.data2).toISOString()
        );
      });
  };

  renderCode = (obj) => {
    // console.log("obj", obj);
    // console.log("obj", this.props);
    return `${this.props.apartmentName.split(" ").reverse()[0]}${obj.tipologia
      .slice(0, 2)
      .toUpperCase()}${obj.id}`;
  };

  render() {
    const textAllertVersamento = [
      {
        text: "Attenzione",
        fontSize: 32,
        paddingBottom: "3vh",
      },
      {
        text: "La seguente operazione non potrà essere annullata.",
        fontSize: 18,
      },
      {
        text:
          "Procedere con il versamento di " +
          this.state.versamento +
          " euro sul conto di " +
          this.state.user +
          "?",
        fontSize: 18,
        paddingBottom: "3vh",
      },
    ];

    const versamenti = this.props.apartment.user.versamenti;
    const servizi = this.props.apartment.user.servizi;

    const printed = this.renderToPrint([...servizi, ...versamenti]);

    // console.log(this.state);

    return (
      <Fragment>
        {!this.state.openStampaVersamento ? (
          <div>
            <div
              className={"hideScrollBar"}
              style={{
                overflowY: "scroll",
                minHeight: "70vh",
              }}
            >
              {this.state.ultimeOperazioni ? (
                <div style={titleStyle}>Ultime Operazioni</div>
              ) : (
                <div style={titleStyle}>
                  Operazioni da {this.state.data1} a {this.state.data2}
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  paddingLeft: paddingLeft,
                  paddingTop: "1.2vh",
                  paddingBottom: "1.2vh",
                }}
              >
                <input type="date" style={{ padding: "1.0vh" }} ref={data1} />
                <input type="date" style={{ padding: "1.0vh", marginLeft: "1.6vw" }} ref={data2} />
                {this.state.ultimeOperazioni ? (
                  <div style={{ paddingLeft: paddingLeft }}>
                    <YellowConfirm
                      text={"Conferma"}
                      action={this.setDate}
                      padding={"1.0vh"}
                      width={"8vw"}
                    />
                  </div>
                ) : (
                  <div style={{ display: "flex", paddingLeft: paddingLeft, alignItems: "center" }}>
                    <YellowConfirm
                      text={"Conferma"}
                      action={this.setDate}
                      padding={"1.0vh"}
                      width={"8vw"}
                    />
                    <div style={{ paddingLeft: paddingLeft }}>
                      <YellowConfirm
                        text={"Rimuovi"}
                        action={this.removeDate}
                        padding={"1.0vh"}
                        width={"8vw"}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div
                className={"hideScrollBar"}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  overflowY: "scroll",
                  paddingTop: 2,
                  maxHeight: "55vh",
                  paddingLeft: paddingLeft,
                  paddingRight: paddingLeft,
                }}
              >
                <div style={{ display: "flex" }}>
                  {headerTabella.map((title, index) => (
                    <div style={columnStyle}>{title.text}</div>
                  ))}
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {printed.slice(0, this.state.visualizzare).map((obj) => (
                    <div style={{ display: "flex", marginTop: 0 }}>
                      {/* <div style={columnStyle}>{`${obj.tipologia.toLowerCase()}_${obj.id}`}</div> */}
                      <div style={columnStyle}>{this.renderCode(obj)}</div>
                      <div style={columnStyle}>{this.ISOtoLongDate(obj.createdAt)}</div>
                      <div style={columnStyle}>{obj.tipologia || obj.descrizione}</div>
                      <div style={columnStyle}>{this.returnPrice(obj)} €</div>
                    </div>
                  ))}
                </div>
                <div
                  style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: 8 }}
                >
                  <Button
                    {...this.props}
                    scope={"plusBilancio"}
                    goTo={() => this.setState({ visualizzare: this.state.visualizzare + 10 })}
                    setDefault={() => this.setState({ visualizzare: 10 })}
                    arrayLength={printed.length}
                    visualizzati={this.state.visualizzare}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: paddingLeft,
                paddingRight: paddingLeft,
                paddingTop: "0.8vh",
                paddingBottom: "0.6vh",
              }}
            >
              <div
                style={{
                  border: "solid",
                  borderWidth: 1,
                  width: "22vw",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Saldo Attuale:{" "}
                {this.renderTotal([
                  ...this.props.apartment.user.servizi,
                  ...this.props.apartment.user.versamenti,
                ])}{" "}
                €
              </div>
              <div style={{ display: "flex" }}>
                <YellowConfirm
                  text={"Versamento"}
                  action={() =>
                    this.setState({ openStampaVersamento: !this.state.openStampaVersamento })
                  }
                  padding={"1.2vh"}
                  width={"8vw"}
                />
                <div style={{ marginLeft: paddingLeft }}>
                  <YellowConfirm
                    text={"Stampa"}
                    action={this.confirm}
                    // action={() => this.setState({ openStampa1: !this.state.openStampa1 })}
                    padding={"1.2vh"}
                    width={"8vw"}
                  />
                </div>
              </div>
            </div>
            <TransitionGroup>
              <CSSTransition
                classNames={"fade"}
                key={Math.random()}
                timeout={{ enter: 500, exit: 500 }}
                in={this.state.inProp}
                unmountOnExit={true}
              >
                {this.state.openStampa1 ? (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      height: window.innerHeight,
                      width: window.innerWidth,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      zIndex: 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        width: "40vw",
                        height: "40vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        zIndex: 200,
                      }}
                    >
                      {textAllert.map((textAllert) => (
                        <div
                          style={{
                            fontSize: textAllert.fontSize,
                            paddingBottom: textAllert.paddingBottom,
                            paddingLeft: "4vw",
                            paddingRight: "4vw",
                          }}
                        >
                          {textAllert.text}
                        </div>
                      ))}
                      <YellowConfirm
                        text={"Conferma"}
                        action={this.confirm}
                        padding={"1.5vh"}
                        width={"8vw"}
                      />
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "none" }}>hidden</div>
                )}
              </CSSTransition>
            </TransitionGroup>
            <TransitionGroup>
              <CSSTransition
                classNames={"fade"}
                key={Math.random()}
                timeout={{ enter: 500, exit: 500 }}
                in={this.state.inProp}
                unmountOnExit={true}
              >
                {this.state.openStampa2 ? (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      height: window.innerHeight,
                      width: window.innerWidth,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      zIndex: 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        width: "40vw",
                        height: "40vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        zIndex: 200,
                      }}
                    >
                      <div style={{ color: "#645B40", fontSize: 36 }}>Operazione Completata</div>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "none" }}>hidden</div>
                )}
              </CSSTransition>
            </TransitionGroup>
            <TransitionGroup>
              <CSSTransition
                classNames={"fade"}
                key={Math.random()}
                timeout={{ enter: 500, exit: 500 }}
                in={this.state.inProp}
                unmountOnExit={true}
              >
                {this.state.openStampaVersamento1 ? (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      height: window.innerHeight,
                      width: window.innerWidth,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      zIndex: 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() =>
                      this.setState({ openStampaVersamento1: !this.state.openStampaVersamento1 })
                    }
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        width: "40vw",
                        height: "40vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        zIndex: 200,
                      }}
                    >
                      {textAllertVersamento.map((textAllert) => (
                        <div
                          style={{
                            fontSize: textAllert.fontSize,
                            paddingBottom: textAllert.paddingBottom,
                            paddingLeft: "4vw",
                            paddingRight: "4vw",
                          }}
                        >
                          {textAllert.text}
                        </div>
                      ))}
                      <YellowConfirm
                        text={"Conferma Versamento"}
                        action={this.confirmVersamento}
                        padding={"1.5vh"}
                        width={"8vw"}
                      />
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "none" }}>hidden</div>
                )}
              </CSSTransition>
            </TransitionGroup>
            <TransitionGroup>
              <CSSTransition
                classNames={"fade"}
                key={Math.random()}
                timeout={{ enter: 500, exit: 500 }}
                in={this.state.inProp}
                unmountOnExit={true}
              >
                {this.state.openStampaVersamento2 ? (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      height: window.innerHeight,
                      width: window.innerWidth,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      zIndex: 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() =>
                      this.setState({ openStampaVersamento1: !this.state.openStampaVersamento1 })
                    }
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        width: "40vw",
                        height: "40vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        zIndex: 200,
                      }}
                    >
                      <div style={{ color: "#645B40", fontSize: 36 }}>Operazione Completata</div>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "none" }}>hidden</div>
                )}
              </CSSTransition>
            </TransitionGroup>
          </div>
        ) : (
          <div>
            <div style={titleStyle}>Versamento</div>
            <div
              style={{
                display: "flex",
                paddingLeft: paddingLeft,
                paddingTop: "1.2vh",
                paddingBottom: "1.2vh",
              }}
            >
              <div>
                <input
                  type="date"
                  style={{ padding: "1.0vh", width: "16vw", border: "none", fontSize: 18 }}
                  ref={data}
                />
              </div>
              <div>
                <input
                  type="text"
                  style={{
                    padding: "1.0vh",
                    marginLeft: "1.6vw",
                    marginRight: "1.6vw",
                    width: "16vw",
                    border: "none",
                    fontSize: 18,
                  }}
                  placeholder={"Valore Versamento"}
                  ref={versamento}
                />
              </div>
              <YellowConfirm
                text={"Conferma"}
                action={() =>
                  this.setState({
                    openStampaVersamento: !this.state.openStampaVersamento,
                    openStampaVersamento1: !this.state.openStampaVersamento1,
                    versamento: versamento.current.value,
                    dataVersamento: data.current.value,
                  })
                }
                padding={"1.2vh"}
                width={"8vw"}
              />
            </div>
            <div style={{ display: "flex", paddingLeft: paddingLeft }}>
              <div
                style={{
                  marginTop: "2vh",
                  border: "solid",
                  borderWidth: 1,
                  width: "calc(16vw - 2px)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // marginLeft: "1.6vw",
                  padding: "1vh",
                  fontSize: 18,
                }}
              >
                Saldo Attuale:{" "}
                {this.renderTotal([
                  ...this.props.apartment.user.servizi,
                  ...this.props.apartment.user.versamenti,
                ])}{" "}
                €
              </div>
              <div
                style={{
                  marginTop: "2vh",
                  border: "solid",
                  borderWidth: 1,
                  width: "calc(16vw - 2px)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "1.6vw",
                  marginRight: "1.6vw",
                  padding: "1vh",
                  fontSize: 18,
                }}
              >
                Saldo Attuale:{" "}
                {this.renderTotal([
                  ...this.props.apartment.user.servizi,
                  ...this.props.apartment.user.versamenti,
                ]) + this.state.versamento}{" "}
                €
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  apartments: state.apartments.data,
  apartment: state.apartments.singleApartment,
  loading: state.apartments.loading,
  error: state.apartments.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addVersamento: (apartmentName, data, value) =>
      dispatch(addVersamento(apartmentName, data, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Bilancio);
